import { Route } from 'react-router-dom';

import { SettingsEmailDomainsTableView } from 'app/views/layout/views/settings/views/email/views/emailDomains/settingsEmailDomainsTableView';

import { SettingsEmailView } from './settingsEmail.view';
import { SettingsEmailTableView } from './views/email/settingsEmailTableView';

export const settingsEmailRoutes = (
  <Route path="email" element={<SettingsEmailView />}>
    <Route index element={<SettingsEmailTableView />} />
    <Route path="domains" element={<SettingsEmailDomainsTableView />} />
  </Route>
);
